export default "__VITE_ASSET__DUUhfV6t__"